import { farasod } from "./api"

const endpoint = "/subscription-level"

export const getAccountSubscriptionLevels = async () => {
  const response = await farasod.get(`${endpoint}`)

  return response.data
}

export const createSubscriptionLevel = async (data) => {
  const response = await farasod.post(`${endpoint}`, data)

  return response.data
}

export const updateSubscriptionLevel = async (subscriptionLevelId, data) => {
  const response = await farasod.patch(`${endpoint}/${subscriptionLevelId}`, data)

  return response.data
}

export const deleteSubscriptionLevel = async (subscriptionLevelId) => {
  const response = await farasod.delete(`${endpoint}/${subscriptionLevelId}`)

  return response.data
}